import React, { useState } from 'react';
import DealCard from './DealCard';

const PipelineColumn = ({
  stage,
  deals,
  onDragStart,
  onDragOver,
  onDrop,
  onEditDeal
}) => {
  const [draggedOverColumn, setDraggedOverColumn] = React.useState(false);
  const [draggedDealId, setDraggedDealId] = React.useState(null);

  const getStageColor = (stageName) => {
    const colors = {
      'Lead': 'bg-blue-200 dark:bg-blue-800',
      'Qualified': 'bg-purple-200 dark:bg-purple-800',
      'Proposal': 'bg-pink-200 dark:bg-pink-800',
      'Negotiation': 'bg-yellow-200 dark:bg-yellow-800',
      'Closed Won': 'bg-green-200 dark:bg-green-800',
      'Closed Lost': 'bg-red-200 dark:bg-red-800'
    };
    return colors?.[stageName] || 'bg-gray-200 dark:bg-gray-700';
  };

  const handleDragOver = (e) => {
    e?.preventDefault();
    setDraggedOverColumn(true);
  };

  const handleDragLeave = () => {
    setDraggedOverColumn(false);
  };

  const handleDrop = (e) => {
    e?.preventDefault();
    setDraggedOverColumn(false);
    setDraggedDealId(null);
    onDrop(stage);
  };

  const handleDragStart = (deal) => {
    setDraggedDealId(deal?.id);
    onDragStart(deal);
  };

  return (
    <div
      className={`flex flex-col min-w-[280px] md:min-w-[320px] lg:min-w-[360px] flex-shrink-0 transition-all duration-250 ${
        draggedOverColumn ? 'scale-105' : 'scale-100'
      }`}
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
      onDrop={handleDrop}
    >
      <div className={`${getStageColor(stage)} rounded-t-xl px-4 md:px-5 py-3 md:py-4`}>
        <div className="flex items-center justify-between">
          <h2 className="text-base md:text-lg font-semibold text-foreground">
            {stage}
          </h2>
          <span className="bg-surface text-foreground text-xs md:text-sm font-medium px-2 md:px-3 py-1 rounded-full data-text">
            {deals?.length}
          </span>
        </div>
      </div>
      <div
        className={`flex-1 bg-muted/30 rounded-b-xl p-3 md:p-4 space-y-3 md:space-y-4 min-h-[400px] md:min-h-[500px] lg:min-h-[600px] transition-all duration-250 ${
          draggedOverColumn ? 'bg-muted/50 ring-2 ring-primary' : ''
        }`}
      >
        {deals?.length === 0 ? (
          <div className="flex items-center justify-center h-32 text-muted-foreground text-sm">
            No deals in this stage
          </div>
        ) : (
          deals?.map((deal) => (
            <div
              key={deal?.id}
              draggable
              onDragStart={() => handleDragStart(deal)}
            >
              <DealCard deal={deal} onEdit={onEditDeal} isDragging={draggedDealId === deal?.id} />
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default PipelineColumn;